// ── RFQ global configuration ──────────────────────────────────────────────────
// Edit these values to change behaviour across the entire app.

/** Quote timer window in milliseconds. Default: 30 seconds. */
export const RFQ_QUOTE_TIMER_MS = 300_000

/** localStorage key that stores the array of accepted RFQ orders. */
export const RFQ_LS_KEY = 'cfx_rfq_orders'
